/*
 * @Author: your name
 * @Date: 2021-12-09 10:58:58
 * @LastEditTime: 2021-12-21 10:54:41
 * @LastEditors: Please set LastEditors
 * @Description: 工程管理路由
 * @FilePath: \dhr_frontend\src\routes\modules\projectManagement.js
 */
export default [
  {
    name: 'projectTypeManagement',
    path: '/projectManagement/projectTypeManagement',
    component: () => import('@/views/projectManagement/projectTypeManagement/projectTypeManagement.vue'),
    meta: {
      title: '项目类型管理'
    }
  },
  {
    name: 'mainProjectManagement',
    path: '/projectManagement/mainProjectManagement',
    component: () => import('@/views/projectManagement/mainProjectManagement/mainProjectManagement.vue'),
    meta: {
      title: '主项目管理'
    }
  },
  {
    name: 'addMainProject',
    path: '/projectManagement/addMainProject',
    component: () => import('@/views/projectManagement/mainProjectManagement/addMainProject.vue'),
    meta: {
      title: '主项目管理添加',
      parentAuth: '/projectManagement/mainProjectManagement',
    }
  },
  {
    name: 'editMainProject',
    path: '/projectManagement/editMainProject',
    component: () => import('@/views/projectManagement/mainProjectManagement/editMainProject.vue'),
    meta: {
      title: '主项目管理编辑',
      parentAuth: '/projectManagement/mainProjectManagement',
    }
  },
  {
    name: 'subProjectManagement',
    path: '/projectManagement/subProjectManagement',
    component: () => import('@/views/projectManagement/subProjectManagement/subProjectManagement.vue'),
    meta: {
      title: '子项目管理'
    }
  },
  {
    name: 'addSubProject',
    path: '/projectManagement/addSubProject',
    component: () => import('@/views/projectManagement/subProjectManagement/addSubProject.vue'),
    meta: {
      title: '子项目管理添加',
      parentAuth: '/projectManagement/subProjectManagement',
    }
  },
  {
    name: 'editSubProject',
    path: '/projectManagement/editSubProject',
    component: () => import('@/views/projectManagement/subProjectManagement/editSubProject.vue'),
    meta: {
      title: '子项目管理编辑',
      parentAuth: '/projectManagement/subProjectManagement',
    }
  }

]
